import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const COUNTDOWN_SECONDS = 10;

interface PermissionUpdatedModalProps {
  visible: boolean;
}

const PermissionUpdatedModal = ({ visible }: PermissionUpdatedModalProps) => {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (visible) {
      setSecondsLeft(COUNTDOWN_SECONDS);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) return undefined;

    if (secondsLeft <= 0) {
      window.location.reload();
      return undefined;
    }

    const timer = setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [visible, secondsLeft]);

  return (
    <Dialog
      header="Permissions Updated"
      visible={visible}
      style={{ width: "450px" }}
      onHide={() => window.location.reload()}
      draggable={false}
      closable={false}
      footer={
        <div className="flex justify-end">
          <Button
            label={`Close (${secondsLeft})`}
            className="bg-layoutBlue border-layoutBlue"
            onClick={() => window.location.reload()}
          />
        </div>
      }
    >
      <p className="mt-3">
        Advisor has changed your permissions, you can continue working as per updated permissions.
      </p>
    </Dialog>
  );
};

export default PermissionUpdatedModal;
